import React from 'react';
import ReactDOM from 'react-dom/client';
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './index.css';
import App from './App';
import AllProductsPage from './components/AllProductsPage';
import { isAllProductsRoute } from './utils/routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
const AppEntry = () => (isAllProductsRoute() ? <AllProductsPage /> : <App />);

root.render(
  <React.StrictMode>
    <AppEntry />
  </React.StrictMode>
);
